import React from 'react';
import {Card as DsCard, FlexColumn} from '@forecast-it/design-system';

type Props = {children: React.ReactNode; 'data-cy'?: string};

export const Card = ({children, 'data-cy': dataCy}: Props): JSX.Element => (
	<DsCard alignment={DsCard.ALIGNMENT.VERTICAL} data-cy={dataCy}>
		<FlexColumn gap="l">{children}</FlexColumn>
	</DsCard>
);
